import LaunchDarkly from '@module/launchdarkly';

import { userHasPlusTier } from '@app/helper/user';

import { FF_COOKIE_WALL } from '@app/constant/experiments';

export const shouldDisplayCookieWall = ({ user, session }) => {
  if (!user || !session) {
    return true;
  }

  if (
    // has Feature Flag Enabled
    LaunchDarkly.getVariant(FF_COOKIE_WALL) &&
    // exclude Pro's
    !userHasPlusTier(user) &&
    // Has not yet seen the cookie notification (wall/banner)
    (typeof session.privacy === 'undefined' || !session.privacy.notified)
  ) {
    return true;
  }

  return false;
};
